module.exports = __webpack_public_path__ + "res/Roboto-Light-webfont.eot?23d8d5c71fabe59ed3eb33c1cf1f687b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Light-webfont.eot
// module id = 66
// module chunks = 0